import { APP_STATUS, type ApplicationStatus } from "../../api/gigboard";
import type { BoardTrack, Track } from "../../api/types";

/** "Today", "Yesterday", "3 days ago", "1 week ago", "5 weeks ago". Empty for a missing or future date. */
export function agoText(value: string | null | undefined, now = Date.now()): string {
  if (!value) return "";
  const days = (now - new Date(value).getTime()) / 864e5;
  if (!(days >= 0)) return "";
  if (days < 1) return "Today";
  if (days < 2) return "Yesterday";
  if (days < 7) return `${Math.floor(days)} days ago`;
  if (days < 14) return "1 week ago";
  return `${Math.floor(days / 7)} weeks ago`;
}

/** The board's tracks: the four skills, plus transferable-skill work open to everyone. */
export function boardTrackLabel(track: BoardTrack, labels: Record<Track, string>): string {
  return track === "transferable" ? "Transferable skills" : (labels[track] ?? track);
}

export function statusLabel(status: ApplicationStatus): string {
  return APP_STATUS.find(([value]) => value === status)?.[1] ?? "Clicked";
}

export const formatCount = (n: number | null | undefined) => Number(n || 0).toLocaleString("en-US");
